import React from 'react';

export default function TransparentBackgroundLayer(){

    return( <div className="transparent-brackground-layer">
        <div id="transparent-layer-id" className="transparent-layer"></div>
      </div>)
}